<template>
  <el-form-item :label="$t('newApp.activityInfo.artpl')" class="folding" :prop="prop">
    <template v-if="!readOnly">
      <el-checkbox-group :value="value" @input="onCheckboxChange" :disabled="disabled">
        <el-checkbox
          v-for="item in filteredProductLineSupplementList"
          :key="item.fieldKey"
          :label="item.fieldKey"
          name="productlineSupplementType"
        >
          {{ getProductLineDisplayName(item) }}
        </el-checkbox>
      </el-checkbox-group>
      <div v-if="showOtherInput && internalOtherShow">
        <el-input
          type="textarea"
          :value="productlineOther"
          @input="$emit('update:productline-other', $event)"
          :disabled="disabled"
          maxlength="50"
        />
      </div>
    </template>
    <div v-else class="custom">{{ readOnlyText }}</div>
  </el-form-item>
</template>

<script>
// 受限选项 fieldKey（仅简化UI用户可见）
const SIMPLIFIED_UI_ONLY_KEYS = ['PS_32', 'PS_33', 'PG_35'];
// 简化UI下隐藏的选项 fieldKey
const SIMPLIFIED_UI_HIDDEN_KEYS = ['PL_01-1'];

export default {
  name: 'ProductLineSelect',
  props: {
    // v-model 绑定，选中的 fieldKey 编码数组
    value: {
      type: Array,
      default: () => []
    },
    // 选项数据源（父组件从 API 获取后传入）
    productlineSupplementList: {
      type: Array,
      default: () => []
    },
    // el-form-item 的 prop（用于表单校验）
    prop: {
      type: String,
      default: 'productlineSupplement'
    },
    // checkbox 禁用状态
    disabled: {
      type: Boolean,
      default: false
    },
    // 只读模式（隐藏 checkbox，显示纯文本）
    readOnly: {
      type: Boolean,
      default: false
    },
    // 只读模式下显示的文本
    readOnlyText: {
      type: String,
      default: ''
    },
    // 是否启用"其他"文本输入
    showOtherInput: {
      type: Boolean,
      default: true
    },
    // "其他"文本值（.sync 双向绑定）
    productlineOther: {
      type: String,
      default: ''
    },
    // 活动编码（productlineSupplementFilter 输出用）
    activityCode: {
      type: String,
      default: ''
    },
    // 报告类型（activityInfo 传 1，industryInfo 传 0，其余不传）
    reportType: {
      type: Number,
      default: undefined
    }
  },
  data () {
    return {
      internalOtherShow: false
    };
  },
  computed: {
    // 过滤后的产品线选项（处理简化UI限制）
    filteredProductLineSupplementList () {
      const isSimplifiedUI = this.$store.state.useSimplifiedForm;
      if (!this.productlineSupplementList) return [];
      return this.productlineSupplementList.filter(item => {
        if (SIMPLIFIED_UI_ONLY_KEYS.includes(item.fieldKey) && !isSimplifiedUI) {
          return false;
        }
        if (SIMPLIFIED_UI_HIDDEN_KEYS.includes(item.fieldKey) && isSimplifiedUI) {
          return false;
        }
        return true;
      });
    }
  },
  methods: {
    // 获取产品线选项的显示名称
    getProductLineDisplayName (item) {
      return item.fieldValue;
    },
    onCheckboxChange (val) {
      this.$emit('input', val);
      this.$emit('change', val);
      // 判断"其他"选项是否被选中
      const otherSelected = val.some(code => {
        const matched = this.productlineSupplementList.find(item => item.fieldKey === code);
        return matched && matched.fieldValue.indexOf(this.$t('general.Other')) >= 0;
      });
      this.internalOtherShow = otherSelected;
      this.$emit('other-change', otherSelected);
    },
    /**
     * 构建提交用的产品线数组
     * 供父组件通过 $refs 调用
     */
    productlineSupplementFilter () {
      const returnVal = [];
      for (const code of this.value) {
        // 使用过滤后的可用列表查找，确保不可用产品线不会被提交
        const item = this.filteredProductLineSupplementList.find(i => i.fieldKey === code);
        if (item) {
          const entry = {
            id: item.id,
            activityCode: this.activityCode,
            productLineCode: item.fieldKey,
            productLineName: this.getProductLineDisplayName(item),
            customProductLine: item.fieldValue.indexOf(this.$t('general.Other')) >= 0 ? this.productlineOther : ''
          };
          if (this.reportType !== undefined) {
            entry.reportType = this.reportType;
          }
          returnVal.push(entry);
        }
      }
      return returnVal;
    },
    /**
     * 从后端数据初始化选中状态（编辑回显）
     * @param {Array} mactProductLineList - editEchoData.mactProductLineList
     * @param {Object} options - { filterReportType?: number }
     * @returns {{ productlineView: string }}
     */
    initFromEchoData (mactProductLineList, options = {}) {
      if (!mactProductLineList || mactProductLineList.length === 0) return { productlineView: '' };
      let list = mactProductLineList;
      if (options.filterReportType !== undefined) {
        list = list.filter(item => item.reportType === options.filterReportType);
      }
      // 过滤不在当前可用列表中的历史选项，避免隐式提交不可用产品线
      const filtered = this.filteredProductLineSupplementList;
      if (filtered && filtered.length > 0) {
        const availableKeys = new Set(filtered.map(i => i.fieldKey));
        list = list.filter(item => availableKeys.has(item.productLineCode));
      }
      const codes = [];
      const names = [];
      list.forEach(item => {
        if (item.productLineName.indexOf(this.$t('general.Other')) >= 0) {
          this.internalOtherShow = true;
          this.$emit('update:productline-other', item.customProductLine);
          names.push(item.customProductLine);
        } else {
          names.push(item.productLineName);
        }
        codes.push(item.productLineCode);
      });
      this.$emit('input', codes);
      return { productlineView: names.join('，') };
    }
  }
};
</script>
